// react components
import React from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type TextInput819SiteProps = {
    disabled?: boolean
    error: string | undefined
    label: string
    name: string
    onChange: any
    placeholder?: string
    value: string | number
}

// main
export const TextInput819Site: React.FC<TextInput819SiteProps> = React.memo(({
    disabled,
    error,
    label,
    name,
    onChange,
    placeholder,
    value,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    function onInputChange(targetValue: string) {
        try {
            onChange({
                name: name,
                value: targetValue,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextInput819Site',
                'onInputChange',
            ))
        }
    }

    return (
        <div className={`input-819 text-input-819 ${deviceType}`}>
            <span className={`input-819-label ${deviceType}`}>{label}</span>
            <input
                className={`ti-819-input ${deviceType}`}
                disabled={disabled}
                name={name}
                placeholder={placeholder}
                onChange={(e) => onInputChange(e.target.value)}
                value={value}
            />
            {error && <span className='input-819-error'>{error}</span>}
        </div>
    )
})
